var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-input-inline"},[_c('v-color-picker',{attrs:{"mode":"rgba","canvas-height":"45px","hide-inputs":"","hide-mode-switch":"","value":_vm.value8Bit},on:{"input":_vm.handleInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }